import React, { FC, useState, useEffect } from 'react'
import { Button, Table, Input, Row, Col, Form, DatePicker } from 'antd'
import { YhBox } from '@/components/YhBox'
import { ColumnsType } from 'antd/es/table'
import { RouterParamType } from '@/model/navModel'
import { supplierService } from '../../../supplierService'
import { IFmsSupplierBillDetail, IFmsSupplierBillPageSearch, ISupplierPurchaseInvoiceSearchFields } from '../../../supplierTypes'
import { ISearchPage, IPgProps } from '@/types/ScmTypes'
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from '@/utils/constants'
import { TablePaginationConfig } from 'antd/lib/table'
import { transPgToPagination } from '@/model/globalModel'
import { useSupplierDetailsMode } from '../supplierDetailsModel'
import { inquiryService } from '@/views/inquiry/inquiryService'
import YhTootip from '@/components/YhTootip'
import { DatePickerProps } from 'antd/lib/date-picker'
import { Moment } from 'moment'
import { RangeValue } from 'rc-picker/lib/interface'
const { RangePicker } = DatePicker

export const PurchaseInvoice: FC<RouterParamType> = ({ id, mode }) => {
    const { editFormVal } = useSupplierDetailsMode()
    // 查询条件
    const [searchParam, setSearchParam] = useState<ISupplierPurchaseInvoiceSearchFields>({})

    // 数据源
    const [dataSource, setDataSource] = useState<IFmsSupplierBillDetail[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    // 分页配置
    const initPgCfg: TablePaginationConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        current: DEFAULT_FIRST_PAGE_NUM,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)

    useEffect(() => {
        if (editFormVal.code) {
            loadData()
        }
    }, [editFormVal.code])

    // 表格列定义
    const columns: ColumnsType<IFmsSupplierBillDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: 'left',
            align: 'center',
            render: (t: any, r: any, i: number) => (pgCfg.current! - 1) * pgCfg.pageSize! + i + 1,
        },
        {
            title: '采购门店单位',
            width: 140,
            dataIndex: 'shopName',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '采购单号',
            width: 120,
            dataIndex: 'tradeCode',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '账单金额',
            width: 120,
            dataIndex: 'billAmount',
            render: (value: number) => value?.toFixed(2),
        },
        {
            title: '结算时间',
            width: 100,
            dataIndex: 'createTime',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '操作人',
            width: 120,
            dataIndex: 'tradeOperator',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '状态',
            width: 160,
            dataIndex: 'status',
            render: (value: number) => {
                if (value === 1) {
                    return '已记账'
                } else if (value === 2) {
                    return '已核销'
                }
            },
        },
        {
            title: '核销人',
            width: 120,
            dataIndex: 'writeoffUser',
            render: (text: string) => <YhTootip text={text} />,
        },
        {
            title: '核销时间',
            width: 120,
            dataIndex: 'writeoffTime',
            render: (text: string) => <YhTootip text={text} />,
        },
    ]

    // 加载数据
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: ISupplierPurchaseInvoiceSearchFields = searchParam) => {
        setLoading(true)
        try {
            let searchParams: IFmsSupplierBillPageSearch = {
                partnerCode: editFormVal.code as string,
                partnerTypeCode: 'user-type.supplier',
                page: {
                    pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                    pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
                },
                sourceApp: 'fms',
            }

            if (searchValue.billTimeRange && searchValue.billTimeRange?.startTime && searchValue.billTimeRange?.endTime) {
                if (!searchParams.billTimeRange) {
                    searchParams.billTimeRange = {}
                }
                searchParams.billTimeRange.startTime = searchValue.billTimeRange.startTime + ' 00:00:00'
                searchParams.billTimeRange.endTime = searchValue.billTimeRange.endTime + ' 23:59:59'
            }

            const { retData } = await supplierService.fmsSupplierBillPage(searchParams)
            const { records, ...pg } = retData
            setPgCfg(transPgToPagination(pg))
            setDataSource(records || [])
        } catch (error) {
            console.error('加载采购账单数据失败:', error)
            setDataSource([])
        } finally {
            setLoading(false)
        }
    }

    
    const onRangePickerChange = (a: RangeValue<Moment>, b: [string, string]) => {
        let searchFile = {...searchParam, billTimeRange: {
            startTime: b[0],
            endTime: b[1],
        }}
        setSearchParam(searchFile)
        loadData(initPgCfg, searchFile)
    }

    return (
        <YhBox style={{ padding: '20px' }}>
            {/* 查询条件 */}
            <Row gutter={10}>
                <Col span={6}>
                    {/* <Input
                        style={{ flex: 1, marginRight: '10px' }}
                        placeholder="供应商编码"
                        value={searchParam.materialCode}
                        onChange={(e) => {
                            setSearchParam({
                                ...searchParam,
                                materialCode: e.target.value,
                            })
                        }}
                    /> */}
                    <RangePicker style={{ flex: 1, marginRight: '10px' }} format="YYYY-MM-DD"  onChange={onRangePickerChange}/>
                </Col>
            </Row>

            {/* 数据表格 */}
            <Table
                rowKey={(record) => record.id}
                loading={loading}
                columns={columns}
                dataSource={dataSource}
                pagination={{
                    ...pgCfg,
                    position: ['bottomCenter'],
                    showTotal: (total) => `共${total}条`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                }}
                scroll={{ x: 'max-content', y: '400px' }}
            />
        </YhBox>
    )
}
